<template>
  <div
    class="wrapper-course-item d-flex flex-column"
    :class="{ isConference: isConference }"
    @click="goToConference"
  >
    <div
      class="wrapper-item"
      :class="{
        'adjust-x-y': isVertical,
        isConference: isConference || isKeepWatching,
        noHover: noHover || isKeepWatching || $route.name == 'conference-about',
      }"
    >
      <div
        :class="`${isVertical ? 'border-rad-2' : 'border-rad-1'}`"
        class="preview"
      >
        <div v-if="showTitleUpper" class="title-upper mb-4">
          {{ item.name }}
        </div>
        <div
          v-if="!isKeepWatching && !isVertical"
          :class="classObjects"
          :style="`position: relative; border-radius: 6px; background: url(${background_url}), #333; background-size: cover; background-position: center;`"
        >
          <div v-if="isLocked" class="locked">
            <img src="@/assets/images/lock-red.svg" alt="Bloqueado" />
          </div>
        </div>
        <div
          v-else-if="isVertical"
          :class="classObjects"
          :style="`position: relative; border-radius: 6px; background: url(${
            isRanked ? item.vertical_cover : item.course.vertical_cover
          }), #333; background-size: cover; background-position: center;`"
        >
          <div v-if="isLocked" class="locked">
            <img src="@/assets/images/lock-red.svg" alt="Bloqueado" />
          </div>
        </div>
        <div
          v-else
          :class="classObjects"
          :style="`border-radius: 6px; background: url(${keepWatchingImage}), #333; background-size: cover; background-position: center;`"
        ></div>

        <div
          class="wrapper-progress-bar no-hover-info"
          v-if="showProgress || isKeepWatching"
        >
          <div
            class="progress"
            :style="`width: ${allDuration == 0 ? 20 : progress}%`"
          />
        </div>

        <h6 v-if="isKeepWatching" class="pt-2 no-hover-info fw-normal">
          {{ item.name }}
        </h6>
        <div v-if="showInfos" class="pt-3 no-hover-info infos">
          <div class="course-name mb-2">
            <span>
              {{ item.name }}
            </span>
          </div>
          <slot />

          <div v-if="showDate">
            <i class="icon-calendar me-1" />
            <span>
              {{ item.year }}
            </span>
          </div>
        </div>
        <div v-if="showName" class="no-hover-info mt-3">
          <span>
            {{ item.name }}
          </span>
        </div>
      </div>
      <preview-about-item
        v-if="!isLesson && !isKeepWatching"
        :item="previewAboutData"
        :is-conference="isConference"
        :show-know-more="showKnowMore"
        class="item-info border-rad-2"
        :isLocked="isLocked"
        :isVertical="isVertical"
      />
    </div>

    <div v-if="!isConference" class="flex-fill"></div>
  </div>
</template>

<script>
  import isConference from "@/functions/mixins/isConference.js";
  import PreviewAboutItem from "./PreviewAboutItem.vue";
  import get from "lodash/get";

  export default {
    mixins: [isConference],
    components: {
      PreviewAboutItem,
    },
    props: {
      isRanked: {
        type: Boolean,
        default: false,
      },
      isHome: {
        type: Boolean,
        default: false,
      },
      noHover: {
        type: Boolean,
        default: false,
      },
      shape: {
        type: [Array, String],
        default: "horizontal",
      },
      showKnowMore: {
        type: Boolean,
        default: true,
      },
      showProgress: {
        type: Boolean,
        default: false,
      },
      showDate: {
        type: Boolean,
        default: false,
      },
      showName: {
        type: Boolean,
        default: true,
      },
      showTitleUpper: {
        type: Boolean,
        default: false,
      },
      isLesson: {
        type: Boolean,
        default: false,
      },
      isKeepWatching: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        required: false,
        default: () => {},
      },
      imageKey: {
        type: String,
        required: false,
        default: "cover",
      },
      showInfos: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      previewAboutData() {
        if (this.isHome) {
          return {
            ...this.item.course,
            last_lesson: get(this.item, "last_lesson", {}),
          };
        }

        return this.item;
      },
      background_url() {
        if (this.item[this.imageKey]) return this.item[this.imageKey];

        if (
          this.isConference &&
          this.item.conference &&
          this.item.conference.cover
        )
          return this.item.conference.cover;

        if (this.item?.course && this.item?.course.cover)
          return this.item.course.cover;

        if (this.item?.cover) return this.item.cover;

        return "";
      },
      isLocked() {
        return !this.item.has_permission;
      },
      keepWatchingImage() {
        let cover = this.item.cover || "";

        if (this.item.conference && this.item.conference.cover) {
          cover = this.item.conference.cover;
        }

        if (this.item?.course && this.item?.course.cover) {
          cover = this.item?.course.cover;
        }

        return this.isKeepWatching && cover;
      },
      progress() {
        return this.isKeepWatching
          ? (this.item.progress.duration * 100) / this.allDuration
          : this.item.progress;
      },
      allDuration() {
        return this.isKeepWatching
          ? !this.item.course
            ? parseInt(this.item.lesson_duration.split(":")[0]) * 3600 +
              parseInt(this.item.lesson_duration.split(":")[1]) * 60 +
              parseInt(this.item.lesson_duration.split(":")[2])
            : 0
          : 0;
      },
      isVertical() {
        return this.shape === "vertical";
      },
      classObjects() {
        return {
          "wrapper-item-available": true,
          [this.shape + "-layout"]: true,
        };
      },
      authorsFormatted() {
        return this.item.authors.join(", ");
      },
    },
    methods: {
      goToConference() {
        if (this.isKeepWatching) {
          this.$router.push({
            name: this.item.course ? "lesson" : "conference-lesson",
            params: {
              id: get(
                this.item,
                "course",
                get(this.item, "conference.id", undefined)
              ),
              lesson_id: this.item.id,
            },
          });
          return;
        }

        if (this.isLocked) {
          return;
        }

        if (this.isConference && this.isLesson) {
          this.$router.push({
            name: "conference-lesson",
            params: {
              id: this.$route.params.id,
              lesson_id: this.item.id,
            },
          });
        } else if (this.isConference) {
          this.$router.push({
            name: "conference-about",
            params: {
              id: this.item.id,
            },
          });
        } else if (this.isLesson) {
          this.$router.push({
            name: "lesson",
            params: {
              id: this.$route.params.id,
              lesson_id: this.item.id,
            },
          });
        } else {
          const id = this.isHome ? this.item.course.id : this.item.id;
          this.$router.push({
            name: this.aboutRoute,
            params: { id },
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/_variables.scss";
  $height_min_1400: 355px;
  $height_max_1390: fit-content;
  .wrapper-course-item {
    min-height: $height_max_1390;
    z-index: 1000000;

    @media screen and (min-width: 1400px) {
      min-height: $height_min_1400;
    }
    cursor: pointer;

    .locked {
      // background: #333;
      position: absolute;
      right: 8px;
      top: 8px;
    }

    @media (max-width: 768px) {
      min-height: auto;
    }

    &.isConference {
      min-height: auto;
      cursor: pointer;
    }

    .wrapper-item {
      &.border-rad-1 {
        border-radius: 5px;
      }

      &.border-rad-1 {
        border-radius: 10px;
      }

      .preview {
        display: none;
      }

      .preview {
        display: block;
      }

      .item-info {
        display: none;
      }

      @media (min-width: 992px) {
        &:not(.adjust-x-y) {
          max-height: $height_max_1390;
          @media screen and (min-width: 1400px) {
            min-height: $height_min_1400;
          }
        }

        overflow: hidden;
        position: relative;
        transition: transform 0.5s ease-in-out;

        &:hover:not(.noHover) {
          // transition-delay: 1s;
          transform: scale(1.2);
          vertical-align: top;
          z-index: 10001;
          overflow: initial;
          min-width: 320px;
          outline: 3px solid #194129;
          border-radius: 10px;

          @media screen and (min-width: 1380px) {
            min-width: 400px;
          }

          @media screen and (min-width: 1500px) {
            min-width: 450px;
          }

          .wrapper-item-available {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            height: 185.68px;
            width: 100%;
          }

          .item-info {
            display: block;
            width: 100%;
          }

          .no-hover-info {
            display: none;
          }
        }
      }
    }

    .preview {
      .wrapper-item-available {
        border-color: black;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;

        &.vertical-layout {
          aspect-ratio: 185.68/280;
        }

        &.horizontal-layout {
          aspect-ratio: 350/193.98;

          @media screen and (min-width: 1300px) {
            aspect-ratio: 220/121.93;
          }
        }
      }

      .wrapper-progress-bar {
        height: 6px;
        background-color: #0405064d;
        margin-top: -6px;
        border-radius: 0 0 8px 8px;

        .progress {
          height: 100%;
          background-color: $primary;
          border-radius: 0 0 8px 8px;
        }
      }

      .infos {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;

        text-transform: uppercase;

        color: #767676;
      }

      .title-upper {
        font-family: "Inter";
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        height: 38px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .course-name {
        @media (max-width: 991.97px) {
          display: none;
        }

        font-family: "Inter";
        font-style: normal;
        font-weight: 800;
        font-size: 12px;
        line-height: 15px;

        text-transform: uppercase;

        color: #767676;
      }
    }
  }
</style>
